<template>
    <div class="header" :class="{'zIndex-high':zIndexHigh, 'fixed': isFixed}">
        <!-- <div class="left-back" v-show="hideBack"></div> -->
        <img src="../assets/images/btn_head_back.png" class="left-back" @click="back" v-if="!hideBack && !isCustomMethod">
        <img src="../assets/images/btn_head_back.png" class="left-back" @click="customMethod" v-else-if="!hideBack && isCustomMethod">
        <img src="../assets/images/btn_head_back.png" class="left-back invisible" v-else>
        <p class="header-title">{{headTitle}}</p>
        <img src="../assets/images/btn_head_menu.png" class="right-menu" @click="showMenu" v-if="!hideMenu && !isCustomMenuMethod">
        <img src="../assets/images/btn_head_menu.png" class="right-menu" @click="customMenu" v-else-if="!hideMenu && isCustomMenuMethod">
        <img src="../assets/images/btn_head_menu.png" class="right-menu invisible" v-else>
        <slot name="rightCtrl"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            headTitle: {
                type: String,
                default: ""
            },
            hideBack: { //是否隐藏返回按钮
                type: Boolean,
                default: false
            },
            isCustomMethod: { //是否自定义返回事件
                type: Boolean,
                default: false
            },
            hideMenu: { //是否隐藏菜单按钮
                type: Boolean,
                default: true
            },
            isCustomMenuMethod: { //是否自定义按钮事件
                type: Boolean,
                default: false
            },
            zIndexHigh: { //是否高层级
                type: Boolean,
                default: false
            },
            isFixed: { //是否锁顶
                type: Boolean,
                default: false
            },
        },
        // props:["headTitle",'hideBack'],
        methods:{
            back:function () {
                window.history.back();
            },
            //自定义返回
            customMethod(){
                this.$emit("customMethod");
            },
            showMenu:function () {

            },
            //自定义菜单事件
            customMenu(){
                this.$emit("customMenu");
            },
        }
    }
</script>

<style>
    .header{
        flex: 0 0 auto;
        height: 1.06rem;
        background-color: #e6e6e7;
        /* position: fixed;
        top: 0;
        left: 0;
        z-index: 100; */
        width: 100%;
        overflow: hidden;
        /* display: -webkit-box; */
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        z-index: 9;
    }
    .header.fixed{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
    }
    .left-back,.right-menu{
        flex: 0 0 auto;
        width: auto;
        height: 100%;
    }
    .left-back.invisible,.right-menu.invisible{
        opacity: 0;
    }
    .left-back{
        order: 1;
    }
    .right-menu{
        order: 5;
    }
    .header p{
        flex: 1 1 auto;
        order: 3;
        -webkit-box-flex: 1;
        /* box-flex: 1; */
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #19171b;
        font-size: 0.36rem;
    }
    .right-ctrl{
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        height: inherit;
        padding-right: 4%;
        text-align: right;
        font-size: 0.26rem;
        color: #231815;
    }
</style>



// WEBPACK FOOTER //
// src/shared/components/header.vue